import { message } from "antd";
import axios from "axios";
import download from "downloadjs";

// Generate product image
export const generateLinkedinHeadshot =
    (uploaded_image_object, prompt, pose) => async (dispatch) => {
        await axios
            .post(`/api/linkedin_headshots/generate_linkedin_headshot`, {
                uploaded_image: uploaded_image_object,
                prompt: prompt,
                pose: pose,
            })
            .then(async (response) => {
                dispatch({
                    type: "GENERATE_LINKEDIN_HEADSHOT_SUCCESS",
                    payload: response.data,
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Download product image
export const downloadLinkedinHeadshot =
    (linkedin_headshot_uuid, format, resolution, size) => async (dispatch) => {
        await axios
            .get(
                `/api/linkedin_headshots/download/${linkedin_headshot_uuid}/${format}/${resolution}/${size}`,
                {
                    responseType: "arraybuffer",
                }
            )
            .then(async (response) => {
                await download(
                    response.data,
                    `img.${format}`,
                    `image/${format}`
                );
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Fetch seamless products of a user
export const fetchUserLinkedinHeadshots =
    (urlParams, offset, limit) => async (dispatch) => {
        var key = await urlParams.get("key");
        await axios
            .get(
                `/api/linkedin_headshots/user_linkedin_headshots/${key}/${offset}/${limit}`
            )
            .then(async (response) => {
                dispatch({
                    type: "FETCH_USER_LINKEDIN_HEADSHOTS_SUCCESS",
                    payload: response.data,
                    key: "user_linkedin_headshots" + "_" + urlParams.toString(),
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };
